import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import { DatePicker } from '@rio-cloud/rio-uikit';
import moment, { Moment } from 'moment';
import Button from '@rio-cloud/rio-uikit/Button';
import TableSettingsDialog from '@rio-cloud/rio-uikit/TableSettingsDialog';
import TableSearch from '@rio-cloud/rio-uikit/TableSearch';
import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import TableViewToggles, { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';

export type ColumnLabel = { [key: string]: string };

export type ColumnDetails = {
    [key: string]: number;
};

export type ColumnDetailsMap = {
    [key: string]: ColumnDetails;
};

interface Props {
    searchValue: string;
    handleSearchValueChange: (newSearchValue: string) => void;
    openModal?: (open: boolean) => void;
    extraActions?: React.ReactNode;
}

const Toolbar = ({
    searchValue,
    handleSearchValueChange,
    openModal,
    extraActions
}: Props) => {
    return (
        <TableToolbar>
            <div className='table-toolbar-container'>
                <div className='table-toolbar-group-left'>
                    <div className='table-toolbar-column table-toolbar-column-spacer'>
                        <ButtonToolbar className='display-flex flex-wrap gap-10 align-items-center'>
                            <Button bsStyle={Button.PRIMARY} iconName='rioglyph-plus' className='rounded-small width-150' onClick={() => openModal && openModal(true)}>
                               Adicionar
                            </Button>
                            {extraActions}
                        </ButtonToolbar>
                    </div>
                    <div className='table-toolbar-column  display-flex flex-row gap-10 align-items-center'>
                        <div >
                            <TableSearch
                                className='rounded-small width-300'
                                value={searchValue}
                                onChange={handleSearchValueChange}
                                placeholder='Buscar'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </TableToolbar>
    )
}

export default Toolbar;